export const loginStackRelativePath = '/login-ui/'
